"use client";

import { Pagination } from "@/components/ui/pagination";

export { buildEllipsisPages as buildPageNumbers } from "@/components/ui/pagination";

export function ArTablePagination({
  page,
  totalPages,
  onPageChange,
  disabled,
}: {
  page: number;
  totalPages: number;
  onPageChange: (p: number) => void;
  disabled?: boolean;
}) {
  return (
    <Pagination.Root
      page={page}
      totalPages={totalPages}
      onPageChange={onPageChange}
      variant="arbitrator"
      disabled={disabled}
    >
      <Pagination.Nav>
        <Pagination.First />
        <Pagination.Prev />
        <Pagination.Pages strategy="ellipsis" />
        <Pagination.Next />
        <Pagination.Last />
      </Pagination.Nav>
    </Pagination.Root>
  );
}
